import logo from './noonlogo.png';
import './App.css';
import './PrivacyAndPolicy';
import PrivacyPolicy from './PrivacyAndPolicy';
import LicenseAgreement from './LicenseAgreement';
import LandingPage from './LandingPage';
import React, { useEffect, useState } from 'react';

function App() {
  const [logo, setLogo] = useState(''); // State to hold the logo image

  useEffect(() => {
    document.title = "Mutabaah"; // Change this to your desired title
    setLogo(logo)
  }, []); // Empty dependency array ensures this effect runs only once after the component mounts

  return (
    <div className="App">
      <LandingPage />
      <PrivacyPolicy />
      <LicenseAgreement />
    </div>
  );
}

export default App;
